<template>
  <div id="home">
    <main id="hero">
      <h1 class="text-dark">Be a new you.</h1>
      <h5 class="text-secondary pl-5 pr-5">
        With LearnNow's collection of self-study resources and qualified
        instructors, you can improve your skills during this quarantine.
      </h5>
      <router-link to="/register" class="btn btn-primary"
        >Try For Free</router-link
      >
    </main>
    <section id="features" class="bg-light">
      <div class="container row mx-auto">
        <div class="feature col-sm">
          <!-- <div class="preview bg-secondary mb-4"></div> -->
          <h5>Achievements</h5>
          <p class="text-secondary">
            LearnNow is built in with progress tracking and achievements which
            serve as motivation for the student.
          </p>
        </div>
        <div class="feature col-sm">
          <!-- <div class="preview bg-secondary mb-4"></div> -->
          <h5>Games</h5>
          <p class="text-secondary">
            LearnNow is uses games to keep the student engaged while learning
            new concepts.
          </p>
        </div>
        <div class="feature col-sm">
          <!-- <div class="preview bg-secondary mb-4"></div> -->
          <h5>Industry Professionals</h5>
          <p class="text-secondary">
            LearnNow has a strict vetting system that allows only the best of
            the best to teach other students.
          </p>
        </div>
        <div class="feature col-sm">
          <!-- <div class="preview bg-secondary mb-4"></div> -->
          <h5>Cheap Cost</h5>
          <p class="text-secondary">
            Compared to many other services we are much cheaper and provide more
            services/value than they do.
          </p>
        </div>
      </div>
    </section>
    <section id="reviews" class="row">
      <div class="card-container">
        <div class="card p-5 mr-5">
          <blockquote class="blockquote text-center">
            <p class="mb-0">
              Sophia has been fantastic in listening to the needs of my
              daughter, and adapting the curriculum to focus on highest leverage
              areas. Sophia is able to tease out and improve upon concepts my
              daughter needs help with, which then enables my daughter to
              independently apply this knowledge to her regular class homework.
            </p>
            <footer class="blockquote-footer">
              Irina S.
            </footer>
          </blockquote>
        </div>
        <div class="card p-5 mr-5">
          <blockquote class="blockquote text-center">
            <p class="mb-0">
              Julia would provide opportunities to take practice tests which
              allowed our daughter the opportunity to properly manage her time.
              In the end, our daughter improved significantly, and master new
              skills. We recommend working with Julia. We would definitely work
              with Julia again.
            </p>
            <footer class="blockquote-footer">
              Jill J.
            </footer>
          </blockquote>
        </div>
        <div class="card p-5 mr-5">
          <blockquote class="blockquote text-center">
            <p class="mb-0">
              She found ways to keep them motivated and engaged, even when they
              struggled with concepts or had a disappointing practice exam. In
              the end, my children were well prepared and confident going into
              the SAT, and the results were better than we expected. Kavya has a
              stress-free approach to coaching, and I recommend her highly.
              She's fantastic.
            </p>
            <footer class="blockquote-footer">
              Kathy L.
            </footer>
          </blockquote>
        </div>
        <div class="card p-5">
          <blockquote class="blockquote text-center">
            <p class="mb-0">
              My daughter worked with Angela Goldberg in both math and English
              for over a year, starting in 8th grade. She had a very positive
              experience. Angela is super nice and approachable, and helped my
              daughter improve significantly in both areas. Working with Angela
              enabled my daughter to not only master the concepts but gain
              confidence in her abilities.
            </p>
            <footer class="blockquote-footer">
              Laren Y.
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
    <section id="api-showcase" class="bg-light">
      <div class="container">
        <div class="row">
          <div class="content col-sm">
            <h1 class="mb-3">"Auto Collections"</h1>
            <p class="text-secondary">
              LearnNow's free tier scoures trust-worthy sources on the internet
              for educational resources and compiles it into an easy to follow
              path for students.
            </p>
          </div>
          <div class="sites col-sm row">
            <ul class="list-group col-12 col-md-6">
              <li class="list-group-item">edX</li>
              <li class="list-group-item">Coursera</li>
              <li class="list-group-item">Youtube</li>
            </ul>
            <ul class="list-group col-12 col-md-6">
              <li class="list-group-item">Udemy</li>
              <li class="list-group-item">Google Scholar</li>
              <li class="list-group-item">Wikipedia</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <main id="hero">
      <h1 class="text-dark">Reinvent yourself.</h1>
      <h5 class="text-secondary pl-5 pr-5">
        Learn more about any topic this quarantine with a free three month
        trial.
      </h5>
      <router-link to="/register" class="btn btn-primary"
        >Redeem Trial</router-link
      >
    </main>
    <footer class="bg-dark text-white">
      <div class="container">
        <div class="row">
          <ul class="col-sm">
            <li><strong>Link Group 1</strong></li>
            <li>Link</li>
            <li>Link</li>
          </ul>
          <ul class="col-sm">
            <li><strong>Link Group 2</strong></li>
            <li>Link</li>
            <li>Link</li>
          </ul>
          <ul class="col-sm">
            <li><strong>Link Group 3</strong></li>
            <li>Link</li>
            <li>Link</li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default { name: 'Home' }
</script>

<style lang="scss" scoped>
#home {
  #hero {
    padding: 100px 0 100px 0;
    h1 {
      text-align: center;
      margin-bottom: 20px;
    }
    h5 {
      display: block;
      margin: 0 auto;
      text-align: center;
      margin-bottom: 50px;
    }
    a {
      display: block;
      margin: 0 auto;
      width: 50%;
    }
  }
  #features {
    padding: 100px 0 75px 0;
    .feature {
      .preview {
        height: 150px;
        width: 100%;
      }
    }
  }
  #reviews {
    padding: 100px 0 75px 0;
    .card-container {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
      width: 90vw;
      margin: 0 auto;
      .card {
        flex: 0 0 auto;
        width: 900px;
      }
    }
  }
  #api-showcase {
    padding: 100px 0 75px 0;
  }
  footer {
    padding: 50px 0;
    .row {
      .col-sm {
        list-style: none;
        text-align: center;
        li {
          margin: 10px 0;
        }
      }
    }
  }
}
@media screen and (min-width: 600px) {
  #home {
    #hero {
      h5 {
        width: 50% !important;
      }
      a {
        width: 20%;
      }
    }
    #reviews {
      .card-container {
        width: 80vw !important;
        .card {
          width: 900px !important;
        }
      }
    }
    #api-showcase {
      .sites {
        margin: 0 auto;
      }
    }
  }
}
</style>
